import React from 'react';
import './Button.scss'

export const NavButton = props => {
    return (
        <button className="active-btn" onClick={props.onClick} >{props.btnText}</button>
    )
}

export const SelectButton = props => {
    return (
        <button className={props.className} onClick={props.onClick} value={props.value} name={props.name}>{props.btnText}</button>  
    )
}
